import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import GenericEvent from './GenericEvent'

const END_USER_ICON_SRC = require('images/svg/flower-pot-navy.svg')

class EndUserAddedEvent extends Component {
  render() {
    const { org } = this.props
    const eventProps = {
      iconSrc: END_USER_ICON_SRC,
      eventLabel: "added to",
      ...this.props
    }
    return (
      <GenericEvent {...eventProps }>
        {org.name}
      </GenericEvent>
    )
  }
}

const container = makeDefaultFailedContainer(EndUserAddedEvent, {
  listenTo: ['stores.OrgStore'],
  fetch: {
    org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    }
  }
})

export default container



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/EndUserAddedEvent.js